module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/footer/footer.component.scss
// module id = ./src/app/shared/footer/footer.component.scss
// module chunks = main